import { RequestOptions, Headers } from '@angular/http';

//you can move this class to a better place
export class GlobalHttpOptions extends RequestOptions {
    constructor() {
        super({
            withCredentials: true
        });
    }
}


// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/global-http-options.ts